<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
    width="600px"
    append-to-body
     v-dialogDrag
    :visible.sync="visible">
    <el-button v-if="method != 'add'" size="medium" class="mb8" icon="el-icon-edit" type="warning"  @click="handEditorView(method)" :disabled="!hasPermission('unmspace:cecUnmSpanceContent:edit')">编辑</el-button>
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row  :gutter="15">
        <el-col :span="24">
          <el-form-item label="主图" prop="">
                 <CropperView 
                 ref="listImageRef" 
                 :imgSrc="inputForm.pic" 
                 :disabled="method === 'view'"  
                 :actionButtonFlag="true" 
                 :autoCropWidth="80"
                  :autoCropHeight="80"
                 :objectFit="'cover'" 
                 :listIndex="1" 
                 @updateChange="changeImage($event,inputForm)"></CropperView>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="排序" prop="sort"
                :rules="[
                  {required: true, message:'排序不能为空', trigger:'blur'}
                 ]">
              <el-input v-model.number="inputForm.sort" placeholder="请填写排序"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="中文名称" prop="nameCn"
                :rules="[
                  {required: true, message:'中文名称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.nameCn" placeholder="请填写中文名称"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="英文名称" prop="nameEn"
                :rules="[
                  {required: true, message:'英文名称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.nameEn" placeholder="请填写英文名称"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="描述（中）" prop=""
                :rules="[
                 ]">
              <el-input v-model="inputForm.descriptionCn" placeholder="请填写"  maxlength="255"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="描述（英）" prop=""
                :rules="[
                 ]">
              <el-input v-model="inputForm.descriptionEn" placeholder="请填写"  maxlength="255"    ></el-input>
           </el-form-item>
        </el-col>
        <!-- <el-col :span="24">
            <el-form-item label="功能空间" prop="functionalSpace.id"
                :rules="[
                  {required: true, message:'功能空间不能为空', trigger:'blur'}
                 ]">
          <GridSelect
            title="选择功能空间"
            labelName = 'nameEn'
            labelValue = 'id'
            :value = "inputForm.functionalSpace.id"
            :limit="10"
            @getValue='(value) => {inputForm.functionalSpace.id=value}'
            :columns="[
            {
              prop: 'nameCn',
              label: '中文名称'
            },
            {
              prop: 'nameEn',
              label: '英文名称'
            }
            ]"
            :searchs="[
            {
              prop: 'nameCn',
              label: '中文名称'
            },
            {
              prop: 'nameEn',
              label: '英文名称'
            }
            ]"
            dataListUrl="/unmspace/cecUnmFunctionalSpace/list"
            queryEntityUrl="/unmspace/cecUnmFunctionalSpace/queryById">
          </GridSelect>
           </el-form-item>
        </el-col> -->
        
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import GridSelect from '@/components/gridSelect/setIndex.vue'
  import cecUnmSpanceContentService from '@/api/unmspace/cecUnmSpanceContentService'
  import CropperView from '@/components/upload/ImageUploadCropper.vue'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          nameEn: '',
          nameCn: '',
          functionalSpace: {
            id: ''
          },
          sort: '',
          pic: '',
          descriptionEn: '',
          descriptionCn: '',
          coverImage: {
            filePath: '',
            category: '',
            id: ''
          }
        }
      }
    },
    components: {
      GridSelect,
      CropperView
    },
    methods: {
      //  upload image 上传图片
      changeImage (e, item) {
        if (e) {
          item.pic = typeof e === 'string' ? e : e.filePath
          item.coverImage = {
            category: 'spanceContent',
            filePath: typeof e === 'string' ? e : e.filePath
          }
          // this.saveData(item)
        }
      },
      // 切换编辑状态
      handEditorView (method) {
        this.method = method === 'view' ? 'edit' : 'view'
      },
      init (method, id, functionalSpaceId) {
        this.method = method
        this.inputForm.id = id
        this.inputForm.functionalSpace = functionalSpaceId
        if (method === 'add') {
          this.title = `新建功能空间内容管理`
        } else if (method === 'edit') {
          this.title = '修改功能空间内容管理'
        } else if (method === 'view') {
          this.title = '查看功能空间内容管理'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          this.inputForm.pic = ''
          this.inputForm.descriptionCn = ''
          this.inputForm.descriptionEn = ''
          this.$refs.listImageRef.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecUnmSpanceContentService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              if (data.coverImage) {
                this.inputForm.pic = data.coverImage.filePath
              } else {
                this.inputForm.coverImage = {}
              }
              this.loading = false
            })
          }
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmSpanceContentService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success('设置成功')
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>
<style scoped>
::v-deep .el-dialog__body{
 padding: 10px 20px !important;
}
</style>

  
